import React from 'react';
import { GlassCard } from '../components/canvas/GlassCard';
import { SlideLogo } from '../components/canvas/SlideLogo';
import { SlideContent } from '../components/canvas/SlideContent';
import { SlideFooter } from '../components/canvas/SlideFooter';
import { NudgeableGroup } from '../components/canvas/NudgeableGroup';

/**
 * Top Heavy layout — inverted classic.
 * Glass card at TOP with content, logo above footer at BOTTOM.
 * Footer pinned at bottom for cross-template consistency.
 */
export function TopHeavyLayout({ data, fontPreset, logoEnabled = true, logoUrl = null, logoTitle = '', logoSubtitle = '', logoSize = null, logoIsDark = false, pc }) {
  return (
    <>
      {/* Main content card at TOP */}
      <NudgeableGroup groupId="content" className="absolute top-[64px] left-[64px] right-[64px]">
        <GlassCard className="relative p-[56px]" blurLevel={data.glassBlur ?? 3} pc={pc}>
          <SlideContent
            data={data}
            fontPreset={fontPreset}
            pc={pc}
            options={{ showFooter: false }}
          />
        </GlassCard>
      </NudgeableGroup>

      {/* Logo row above footer */}
      {logoEnabled && (
        <NudgeableGroup groupId="logo" className="absolute bottom-[120px] left-[64px]">
          <div className="flex items-center gap-6">
            <SlideLogo className="h-16 w-16" style={{ color: pc.text(0.80) }} logoUrl={logoUrl} size={logoSize} isDark={logoIsDark} />
            {logoTitle && (
              <div className="leading-tight">
                <div
                  className="text-[24px] tracking-[0.22em] font-medium"
                  style={{ marginRight: '-0.22em', color: pc.text(0.65) }}
                >
                  {logoTitle.toUpperCase()}
                </div>
                {logoSubtitle && (
                  <div className="text-[18px] lowercase" style={{ color: pc.text(0.50) }}>
                    {logoSubtitle}
                  </div>
                )}
              </div>
            )}
          </div>
        </NudgeableGroup>
      )}

      {/* Footer — pinned at bottom */}
      <div className="absolute bottom-[64px] left-[64px] right-[64px]">
        <SlideFooter data={data} pc={pc} />
      </div>
    </>
  );
}
